import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

const useClarificationWavesApi = () => {
  const getClarificationWavesNumbersForms = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/request-clarification-waves/request-waves-numbers-forms/${requestId}`
    );
    return response;
  }, []);

  const getClarificationWaveFormData = useCallback(
    async (requestId, waveNumber, formId) => {
      const response = await axiosInstance.get(
        `/api/request-clarification-waves/${requestId}/${formId}/${waveNumber}`
      );
      return response;
    },
    []
  );

  return { getClarificationWavesNumbersForms, getClarificationWaveFormData };
};

export default useClarificationWavesApi;
